import i18n from 'i18next';

import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('inited', { startValue: undefined })
  .addVariable('currentLang', { startValue: i18n.language })
  .addVariable('hasObjectStructure', { startValue: false });
